import jsonschema from "jsonschema";

const validator = new jsonschema.Validator();

function validate(object, schema) {
  const validationResult = validator.validate(object, schema);

  let errorMessage = "";
  if (validationResult.errors.length > 0) {
    errorMessage = validationResult.errors.reduce((allErrors, error) => {
      return `${allErrors} ${error.message}. `;
    }, "");
  }

  return errorMessage;
}

export default validate;



// WEBPACK FOOTER //
// ./src/common/formValidation/validate.js